import Card from 'components/card/Card';
import { bgColor } from 'modules/colors';
import media from 'modules/media';
import { spacing } from 'modules/metrics';
import styled from 'styled-components';

export const Wrapper = styled.div`
  background-color: ${bgColor};
  display: flex;
  justify-content: center;
  padding: 64px;
  padding-bottom: 25%;

  ${media.tablet} {
    padding: ${spacing.xl}px ${spacing.lg}px;
  }
`;

export const CardStyled = styled(Card)`
  max-width: ${(props) => (props.size ? props.size : 450)}px;
  padding: ${spacing.xl}px;
`;
